<template>
  <div>
    <v-card>
      <v-card-title>
        {{ header }}<br />
        <v-spacer></v-spacer>
        <v-btn icon
          ><v-icon color="dark" @click="closeDialog">mdi-close</v-icon></v-btn
        >
      </v-card-title>
      <v-divider class="mx-4 mb-2"></v-divider>
      <ValidationObserver
        ref="observer"
        v-slot="{ dirty, invalid }"
        v-if="action === 'create'"
      >
        <v-card-text>
          <v-row v-for="(entry, index) in emails" :key="index">
            <v-col cols="10" class="py-0">
              <ValidationProvider
                :name="`Email ${entry}`"
                v-slot="{ errors, dirty, invalid }"
                rules="email"
              >
                <v-text-field
                  label="E-mail"
                  dense
                  outlined
                  clearable
                  v-model="emails[index]"
                  :error-messages="
                    errors.length > 0 ? 'Email is invalid' : errors
                  "
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="2" class="py-0"
              ><v-btn
                color="error"
                @click="removeLogin(index)"
                :disabled="emails.length == 1"
                ><v-icon>mdi-trash-can</v-icon></v-btn
              ></v-col
            >
          </v-row>
          <v-row>
            <v-col cols="12" class="d-flex justify-end mb-0">
              <v-btn
                color="primary"
                outlined
                class="mr-2"
                @click="addLogin"
                :disabled="emails.length == 10"
                ><v-icon>mdi-plus</v-icon></v-btn
              >
              <v-btn
                color="primary"
                @click="saveLogins"
                :disabled="!dirty || invalid || !hasEmail"
                >Save Logins</v-btn
              >
            </v-col>
          </v-row>
        </v-card-text>
      </ValidationObserver>
      <ValidationObserver
        ref="observer"
        v-slot="{ dirty, invalid }"
        v-if="action === 'update'"
      >
        <v-card-text>
          <v-row>
            <v-col cols="12" class="py-0">
              <ValidationProvider
                name="Email"
                v-slot="{ errors, dirty, invalid }"
                rules="email"
              >
                <v-text-field
                  label="E-mail"
                  dense
                  outlined
                  clearable
                  v-model="login.email"
                  :error-messages="
                    errors.length > 0 ? 'Email is invalid' : errors
                  "
                ></v-text-field>
              </ValidationProvider> </v-col
          ></v-row>
          <v-row>
            <v-col cols="12" class="d-flex justify-end mb-0">
              <v-btn color="error" class="mr-2">Delete Login</v-btn>
              <v-btn
                color="primary"
                :disabled="!dirty || invalid"
                @click="updateLogin"
                >Update Login</v-btn
              >
            </v-col>
          </v-row>
        </v-card-text>
      </ValidationObserver>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "UpsertWholesalerLogin",
  props: {
    action: {
      type: String,
      required: true
    },
    header: {
      type: String,
      required: true
    },
    modelValue: {
      type: Object,
      required: false
    }
  },
  data: () => ({
    emails: [""],
    hasEmail: false
  }),
  watch: {
    emails() {
      const vm = this;
      const length = vm.emails.length;

      if (length == 1) {
        if (vm.emails[0] !== null && vm.emails[0] !== "") {
          vm.hasEmail = true;
        } else {
          vm.hasEmail = false;
        }
      } else {
        vm.hasEmail = true;
      }
    }
  },
  computed: {
    login: {
      get() {
        const vm = this;
        return vm.modelValue;
      },
      set(value) {
        const vm = this;
        vm.$emit("update", value);
      }
    }
  },
  methods: {
    closeDialog() {
      const vm = this;
      vm.emails = [""];
      vm.$emit("close");
    },
    addLogin() {
      const vm = this;
      vm.emails.push("");
    },
    saveLogins() {
      const vm = this;
      vm.$emit(
        "save",
        vm.emails.filter(e => e !== null && e !== "")
      );
      vm.emails = [""];
      vm.$emit("close");
    },
    updateLogin() {
      const vm = this;
      vm.login = {};
      vm.$emit("close");
    },
    removeLogin(index) {
      let vm = this;
      if (vm.emails.length > 1) {
        vm.emails?.splice(index, 1);
      } else {
        vm.emails = [""];
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
